// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1V1IF","row":"styles_row__3q9DV"};